import { FC } from "react";
import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader } from "@/components/_atoms/card";
import { AvatarWorkspace } from "@/domain/workspace/components/avatar-workspace";
import { Workspace } from "@/domain/workspace/models/workspace-model";

type UserProp = {
  id: string;
  email: string;
  fullname?: string | null | undefined;
  username?: string | null | undefined;
  profilePicture?: string | null | undefined;
  activated: boolean;
};

type TeamProp = {
  id: string;
  name: string;
};

export interface JoinWorkspaceFirstCardProps {
  token: string;
  workspace: Workspace;
  team: TeamProp;
  user: UserProp;
}

export const JoinWorkspaceFirstCard: FC<JoinWorkspaceFirstCardProps> = ({ team, workspace, user }) => {
  const { t } = useTranslation("auth");

  return (
    <Card className="z-10 w-full max-w-xl overflow-hidden border p-10 shadow-xl">
      <CardHeader>
        <div className="flex flex-col gap-4">
          <AvatarWorkspace workspace={workspace} className="h-16 w-16 text-2xl" />
          <h2 className="text-xl">
            {t("invite.joinWorkspaceFirst.title", { name: workspace.name })}
          </h2>
        </div>
      </CardHeader>
      <CardContent>
        <div className="mb-10 mt-4 flex flex-col gap-4">
          <p className="mb-2 text-base font-light text-foreground">
            {t("invite.joinWorkspaceFirst.description", { team: team.name, email: user.email })}
          </p>
          <p className="mb-2 text-base font-light text-foreground">
            {t("invite.joinWorkspaceFirst.checkEmail")}
          </p>
        </div>

        <div className="mt-6 w-full border-t border-solid pt-2">
          <p className="text-sm font-light text-foreground">
            {t("invite.arkDescription")}
          </p>
          <p className="mt-2 text-sm font-light text-foreground">
            {t("invite.learnMore")}{" "}
            <a href="https://ark-climate.de/" target="_blank" className="underline">
              ark-climate.de
            </a>
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
